import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { API } from '../simulator/model';
import { errorDetails } from './model';

export const useSlots = ({ prestation, adresse, devisId, token, enabled = true }) => {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedDay, setSelectedDay] = useState('');
  const [slot, setSlot] = useState(null);
  const [attempt, setAttempt] = useState(0);
  const request = useRef(0);
  const active = enabled && Boolean(devisId ? token : prestation && adresse?.trim().length >= 5);
  const signature = JSON.stringify({ prestation, adresse, devisId, active });
  const [loadedSignature, setLoadedSignature] = useState('');
  useEffect(() => {
    const seq = ++request.current;
    setResult(null); setError(null); setSlot(null); setSelectedDay(''); setLoading(active);
    if (!active) return;
    const controller = new AbortController();
    axios.post(`${API}/api/creneaux`, devisId ? { devis_id: devisId } : { prestation, adresse }, {
      signal: controller.signal, timeout: 35000, headers: token ? { Authorization: `Bearer ${token}` } : {},
    }).then(({ data }) => {
      if (seq !== request.current) return;
      setResult(data); setLoadedSignature(signature); setSelectedDay(data.jours?.[0]?.date || '');
    }).catch((err) => { if (!controller.signal.aborted && seq === request.current) setError(errorDetails(err)); })
      .finally(() => { if (seq === request.current && !controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [active, prestation, adresse, devisId, token, attempt, signature]);
  const reload = useCallback(() => { setSlot(null); setAttempt((value) => value + 1); }, []);
  const chooseDay = (day) => { setSelectedDay(day); setSlot(null); };
  return { result, prestation, loading: active && (loading || (!error && loadedSignature !== signature)), error, selectedDay, slot, setSlot,
    chooseDay, reload, fallback: Boolean(result && (result.hors_zone || result.non_reservable || !result.jours?.length)) };
};